import * as axios from "axios";
import * as firebase from "firebase";
import config from "../../project-config.json";

const firebaseApp = firebase.initializeApp({
  apiKey: config.firebaseKey,
  authDomain: config.firebaseDomain,
  databaseURL: config.firebaseDatabaseUrl,
  projectId: config.firebaseProjectId,
  storageBucket: config.firebaseStorageBucket,
  messagingSenderId: config.firebaseMessagingSenderId
});

const fb = firebaseApp.database();

const roomsRef = fb.ref("/rooms");
const statusesRef = fb.ref("/machineCurrentStatuses");

const getMachines = (orgId, roomId) =>
  axios.get(`${config.allianceApiUrl}/washAlert/machines/${roomId}`, {
    headers: {
      "alliancels-organization-id": orgId
    }
  });

const HTTP = axios.create({
  baseURL: `${config.allianceApiUrl}/`,
  headers: {
    "x-api-key": config.allianceApiKey,
  }
});

const getDirectory = (roomId) => {
  return HTTP.get(`${config.allianceApiUrl}/washAlert/rooms/${roomId}/organization?raw=true`);
};

const getAds = (roomId) => {
  return HTTP.get(`${config.allianceApiUrl}/rooms/${roomId}/ads?raw=true`);
};

const getTemplates = () =>
  HTTP.get(
    `${config.allianceApiUrl}/subscriptionTemplates?eventTypeLookupKey=WASH_ALERT&raw=true`
  );

const submitMachineSubscription = (roomId, machineId, form, template) => {
  return HTTP.post(
    `${config.allianceApiUrl}/subscriptionTemplates/${template.id}/subscriptions`,
    {
      email: form.email,
      phone: form.phone,
      recaptchaToken: form.recaptchaToken,
      subscriptionConditions: [
        // ROOM_ID
        {
          subscriptionConditionTypeId: template.roomId,
          intValue: roomId
        },
        // MACHINE_ID
        {
          subscriptionConditionTypeId: template.machineId,
          intValue: machineId
        },
        // MACHINE_TIME_BEFORE_COMPLETE
        {
          subscriptionConditionTypeId: template.machineTimeId,
          dateValue: form.machineTimeBeforeComplete
        }
      ]
    }
  );
};

const submitRoomSubscription = (roomId, form, template) => {
  return HTTP.post(
    `${config.allianceApiUrl}/subscriptionTemplates/${template.id}/subscriptions`,
    {
      email: form.email,
      phone: form.phone,
      recaptchaToken: form.recaptchaToken,
      subscriptionConditions: [
        // ROOM_ID
        {
          subscriptionConditionTypeId: template.roomId,
          intValue: roomId
        },
        // AVAILABLE_WASHER_COUNT_ABOVE
        {
          subscriptionConditionTypeId: template.washerCountAbove,
          intValue: form.washerCountAbove
        },
        // AVAILABLE_DRYER_COUNT_ABOVE
        {
          subscriptionConditionTypeId: template.dryerCountAbove,
          intValue: form.dryerCountAbove
        }
      ]
    }
  );
};

const sendServiceEmail = (roomId, form) =>
  HTTP.post(`${config.allianceApiUrl}/washAlert/service/${roomId}`, {
    email: form.email,
    phone: form.phone,
    comment: form.comment,
    recaptchaToken: form.recaptchaToken,
  });

export {
  roomsRef,
  statusesRef,
  getTemplates,
  getMachines,
  getAds,
  getDirectory,
  submitMachineSubscription,
  submitRoomSubscription,
  sendServiceEmail
};



// WEBPACK FOOTER //
// ./src/services/data.js